import { motion } from 'framer-motion';
import moment from 'moment';
import Image from 'next/image';
import Link from 'next/link';
import React, { FC } from 'react';

import RenderIf from '@/components/Common/RenderIf';
import CategoryBadge from '@/components/Layout/Header/Search/Suggestions/Badge/Category';
import Top10 from '@/components/Layout/Header/Search/Suggestions/Badge/Top10';

import { Endpoints } from '@/network';
import { generateUrlForImage } from '@/pages/books/[bookId]';
import { Book as IBook } from '@/utils/interfaces/Library/Books';

interface Props {
  book: IBook;
  onClickBook?: () => void;
}

const Book: FC<Props> = ({ book, onClickBook }) => {
  const imageUrl = generateUrlForImage(
    `${process.env.NEXT_PUBLIC_API_READER_URL}/`,
    `${Endpoints.getCoverImagesForBooks}/`,
    `${book?._id}`,
  );

  const formattedBooks = () => {
    let tag: string | null = null;

    if (book?.type === 'comingSoon') {
      tag = 'COMING SOON';
    } else if (moment(book.createdAt).isAfter(moment().subtract(2, 'months'))) {
      tag = 'New';
    } else if (book?.featured) {
      tag = 'BESTSELLER';
    }
    return {
      _id: book?._id,
      coverImageUrl: generateUrlForImage(
        `${process.env.NEXT_PUBLIC_API_READER_URL}/`,
        `${Endpoints.getCoverImagesForBooks}/`,
        `${book?._id}`,
      ),
      title: book?.title,
      externalLink: book?.externalLink,
      slug: book?.slug,
      type: book?.type,
      isExternalLink: book?.isExternalLink,
      totalPages: book?.totalPages,
      author_name: book?.author_list?.[0]?.name,
      tag,
      isFree: book?.type === 'short',
      topTen: book.topRanking,
    };
  };

  const getInternalHref = () => {
    if (formattedBooks().tag === 'COMING SOON') {
      return `/books/${book.slug}-${book._id}/`;
    } else if (formattedBooks().isFree) {
      return `/books/${book.slug}-${book._id}/?short=true`;
    } else {
      return `/books/${book.slug}-${book._id}/`;
    }
  };
  return (
    <motion.div
      key={book._id}
      layout
      initial={{ opacity: 0, y: -12 }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0, y: -12 }}
      transition={{ duration: 0.25, ease: [0.16, 1, 0.3, 1] }}
      className='relative sm:w-[127px] sm:min-w-[127px] w-[110px] min-w-[110px]  aspect-[127/180] rounded overflow-hidden'
    >
      <Link
        onClick={(e) => {
          e.stopPropagation();
          onClickBook?.();
        }}
        href={getInternalHref()}
        className='relative sm:w-full sm:min-w-full w-full min-w-full   '
      >
        <Image
          width={127}
          height={180}
          className='w-full h-full transition-all'
          src={imageUrl}
          alt='Book'
        />
      </Link>
      <CategoryBadge type='BOOK' />
      <RenderIf condition={book?.topRanking}>
        <Top10 className='absolute right-0 top-0' />
      </RenderIf>
    </motion.div>
  );
};

export default Book;
